import React from 'react';

const CopyrightSup = () => {
  return <sup className="copyrightSup">©</sup>;
};

export default CopyrightSup;
